import { render } from "./TextHeader.vue?vue&type=template&id=5ed3282c&scoped=true"
import script from "./TextHeader.vue?vue&type=script&lang=js"
export * from "./TextHeader.vue?vue&type=script&lang=js"

import "./TextHeader.vue?vue&type=style&index=0&id=5ed3282c&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed3282c"]])

export default __exports__